module.exports = __webpack_public_path__ + "static/media/video-asset.c429836c.gif";